export const LOGIN_CLICK_EVENT = 'login_click_event';
export const LAST_SELECTED_ORG_UUID = 'last_selected_org_uuid';
export const LAST_SELECTED_PROJECT_UUID = 'last_selected_project_uuid';
export const USER_LOGGED_IN = 'user_logged_in';

export function setLocalStorage(key: string, value: any) {
  localStorage.setItem(key, JSON.stringify(value));
}

export function getLocalStorage(key: string): any {
  const value = localStorage.getItem(key);
  return value ? JSON.parse(value) : null;
}

export function removeLocalStorage(key: string) {
  localStorage.removeItem(key);
}
